import { ClientSide } from "~/@types";
import { IInArticleNewsletterFields } from "~/@types/generated/contentful";
import SalesforceEmbedForm from "../formCapture/SalesforceEmbedForm";

interface NewsletterFormProps {
  fields: ClientSide<IInArticleNewsletterFields>;
}

export default function InArticleNewsletter({ fields }: NewsletterFormProps) {
  return (
    <div className="col-span-full m-auto mt-8 w-full bg-black py-10 px-4 text-white lg:col-span-6 lg:col-start-4 lg:p-10">
      <SalesforceEmbedForm html={fields.html || ""} styles="mb-0" />
    </div>
  );
}
